import { createRouter, createWebHistory } from "vue-router";
import store from '../store/index'
import Dashboard from "../views/Dashboard.vue";
import RFQ from "../views/RFQ.vue";
import RFQDetail from "../views/RFQDetail.vue";
import PO from "../views/PO.vue";
import PODetail from "../views/PODetail.vue";
import Profile from "../views/Profile.vue";
import Notifications from "../views/Notifications.vue";
import VendorPerformance from "../views/VendorPerformance.vue";
import VendorPerformanceDetail from "../views/VendorPerformanceDetail.vue";
import ForecastMonthly from "../views/ForecastMonthly.vue";         
import ForecastMonthlyDetail from "../views/ForecastMonthlyDetail.vue";         
import QPR from "../views/QPR.vue";
import QPRDetail from "../views/QPRDetail.vue";  
import Delivery from "../views/Delivery.vue";  
import DeliveryDetail from "../views/DeliveryDetail.vue";  
import Certificate from "../views/Certificate.vue";  
import CertificateCreate from "../views/CertificateCreate.vue";  
import CertificateDetail from "../views/CertificateDetail.vue";  
import Kanban from "../views/Kanban.vue";  
import KanbanDetail from "../views/KanbanDetail.vue";  
// import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requireAuth: true },
  },
  {
    path: "/rfq",
    name: "Request For Quotation",
    component: RFQ,
    meta: { requireAuth: true },
  },
  {
    path: "/rfq/:id",
    name: "Request For Quotation Detail",
    component: RFQDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/purchase-order",
    name: "Purchase Order",
    component: PO,
    meta: { requireAuth: true },
  },
  {
    path: "/purchase-order/:id",
    name: "Purchase Order Detail",
    component: PODetail,
    meta: { requireAuth: true },
  },
  {
    path: "/forecast-monthly",
    name: "Forecast Monthly",
    component: ForecastMonthly,
    meta: { requireAuth: true },
  },
  {
    path: "/forecast-monthly/:id",
    name: "Forecast Monthly Detail",
    component: ForecastMonthlyDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/qpr",
    name: "QPR",
    component: QPR,
    meta: { requireAuth: true },
  },
  {
    path: "/qpr/:id",
    name: "QPR Detail",
    component: QPRDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/delivery",
    name: "Daily Delivery",
    component: Delivery,
    meta: { requireAuth: true },
  },
  {
    path: "/delivery/:id",
    name: "Daily Delivery Detail",
    component: DeliveryDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/certificate",
    name: "Certificate of Invoice",
    component: Certificate,
    meta: { requireAuth: true },
  },
  {
    path: "/certificate/create",
    name: "Certificate of Invoice - Create",
    component: CertificateCreate,
    meta: { requireAuth: true },
  },
  {
    path: "/certificate/:id",
    name: "Certificate of Invoice - Detail",
    component: CertificateDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requireAuth: true },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: { requireAuth: true },
  },
  {
    path: "/vendor-performance",
    name: "Supplier Evaluation",
    component: VendorPerformance,
    meta: { requireAuth: true },
  },
  {
    path: "/vendor-performance/:id",
    name: "Supplier Evaluation - Detail",
    component: VendorPerformanceDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/kanban",
    name: "Kanban",
    component: Kanban,
    meta: { requireAuth: true },
  },
  {
    path: "/kanban/:id",
    name: "Kanban - Detail",
    component: KanbanDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  }
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.checkLogin)) {
    if (!store.getters['isLogin']) {
      next()
      return
    }
    // jika belum login atau tidak ada token tersimpan
    next('/')
    return
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (localStorage.getItem('isLogin') || store.getters['isLogin']) {
      next()
      return
    }
    // jika belum login atau tidak ada token tersimpan
    next('/signin')
    return
  }
  next()
})

export default router;
